var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/cloud"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.241 10.7587C18.0244 10.042 17.666 9.41704 17.191 8.90871C16.5827 8.21704 15.7744 7.74204 14.866 7.53371C14.4077 5.45037 13.1244 3.95037 11.2993 3.39204C9.31602 2.77537 7.01602 3.37537 5.57435 4.88371C4.30768 6.20871 3.89102 8.03371 4.38268 9.97537C2.71602 10.3837 1.89102 11.7754 1.79935 13.1004C1.79102 13.192 1.79102 13.2754 1.79102 13.3587C1.79102 14.9254 2.81602 16.6837 5.09935 16.8504H13.7494C14.9327 16.8504 16.066 16.4087 16.9327 15.617C18.291 14.4254 18.791 12.567 18.241 10.7587Z",
    fill: "#2F3137"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectSocial);
export default __webpack_public_path__ + "static/media/object_social.8e8519ddc4c83e8b30b092a34e623ef9.svg";
export { ForwardRef as ReactComponent };